// TODO fix class method not uses this, therefore it is rather util than class method
/* eslint-disable class-methods-use-this */
// TODO fix circular dependencies
/* eslint-disable import/no-cycle */
import { DateTime } from 'luxon';
import { Timezone } from '@/entities';
import { IDomainPrimitive, ValueObject } from './value-object.base';
import { getLocalTimezone } from '../timezones';

export class TimezoneVo extends ValueObject<any> {
  constructor(value: Timezone) {
    super({ value });
  }

  get value(): Timezone {
    return this.props.value;
  }

  static createUtcTimezone() {
    return new TimezoneVo('Etc/UTC');
  }

  static createLocalTimezone() {
    return new TimezoneVo(getLocalTimezone());
  }

  static isValidTimezone(timezone: string): timezone is Timezone {
    return DateTime.local().setZone(timezone).isValid;
  }

  protected validate({ value }: IDomainPrimitive<any>) {
    if (!TimezoneVo.isValidTimezone(value)) {
      throw new Error('Provided value is not a timezone');
    }
  }
}
